import React, { ReactNode, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { bonusColors, bonusGlow, RADIUS_SECTION } from './bonusesTheme';

/**
 * The plate behind the VIP grid ("VIP Bonus Games", 3618:68838). That frame insets its heading by
 * 8/12 and its card grid by 6, which a bare auto-layout row would not - the featured row next to
 * it fills its frame edge to edge and has no plate at all.
 *
 * Its own fill is the one thing on this screen the Dev Mode server would not hand over: the frame
 * carries seven card instances, so get_design_context only ever returns sparse metadata for it.
 * The styling here is the daily-bonus strip's (3491:6192), the one section container in the file
 * that could be read in full - flat surface, duller orange hairline, 10 radius, soft amber glow.
 */
type Props = {
	/** Design-space size; the plate scales itself. */
	designWidth: number;
	designHeight: number;
	scale: number;
	children: ReactNode;
};

export const BonusSection = ({ designWidth, designHeight, scale, children }: Props) => {
	const styles = useMemo(
		() => createStyles(designWidth, designHeight, scale),
		[designWidth, designHeight, scale],
	);
	return <View style={styles.root}>{children}</View>;
};

const createStyles = (designWidth: number, designHeight: number, scale: number) =>
	StyleSheet.create({
		root: {
			width: designWidth * scale,
			height: designHeight * scale,
			borderRadius: RADIUS_SECTION * scale,
			borderWidth: Math.max(1, 1 * scale),
			borderColor: bonusColors.sectionBorder,
			backgroundColor: bonusColors.stripSurface,
			overflow: 'hidden',
			...bonusGlow.section,
		},
	});

export default BonusSection;
